/* AgVolution — brand styling for the Shopify Forms app.
   The app renders inside an OPEN shadow DOM, so theme CSS can't reach it.
   This injects a <style> into each form's shadow root, and converts the
   floating field labels (which overlapped the input) into native input
   placeholders (which disappear as you type) while keeping accessibility via
   aria-label. Button + text colors come from the app block settings (template
   JSON). Targets the app's hashed CSS-module classes via [class*="..."]. */
(function () {
  var CSS = [
    'form { width:100%; box-sizing:border-box; }',
    'input:not([type=checkbox]):not([type=radio]):not([type=submit]):not([type=button]), textarea, select, [class*="formInputField"] {',
    '  width:100% !important; box-sizing:border-box !important; background:#fff !important; color:#1F1F21 !important;',
    '  border:1px solid #D5D9DF !important; border-radius:6px !important; box-shadow:none !important;',
    '  padding:12px 13px !important; font-size:15px !important; font-family:inherit !important; line-height:1.4 !important;',
    '}',
    '[class*="formFieldContainer"], [class*="formField"] { border:0 !important; box-shadow:none !important; background:transparent !important; }',
    '[class*="formFieldContainer"]::before, [class*="formFieldContainer"]::after { display:none !important; }',
    'textarea, [class*="formInputField"][rows] { resize:vertical !important; min-height:90px !important; }',
    'input:focus, textarea:focus, select:focus, [class*="formInputField"]:focus { outline:2px solid #73B823 !important; outline-offset:1px !important; border-color:#73B823 !important; }',
    '[class*="phone"], [class*="Phone"], [class*="tel-"], [class*="iti"] { max-width:100% !important; box-sizing:border-box !important; }',
    '[class*="phone"] input, [class*="Phone"] input { min-width:0 !important; flex:1 1 auto !important; width:100% !important; }',
    '[class*="phone-country-selector"], [class*="countrySelector"] { flex:0 0 auto !important; }',
    /* labels left visible (e.g. above selects) get a tidy uppercase look */
    '[class*="formInputFieldLabel"] { font-size:12px !important; font-weight:600 !important; letter-spacing:.06em !important; text-transform:uppercase !important; }',
    'input::placeholder, textarea::placeholder { color:#8a93a0 !important; opacity:1 !important; }',
    /* submit button: border-box keeps the right corner radius from clipping */
    'button[type=submit], [class*="formSubmitButton"] {',
    '  box-sizing:border-box !important; width:100% !important; font-weight:800 !important; text-transform:uppercase !important;',
    '  letter-spacing:.04em !important; font-size:16px !important; border-radius:8px !important; padding:15px !important; cursor:pointer !important; font-family:inherit !important;',
    '}'
  ].join('\n');

  function inject(root) {
    if (root && !root.querySelector('#agv-forms-style')) {
      var st = document.createElement('style');
      st.id = 'agv-forms-style';
      st.textContent = CSS;
      root.appendChild(st);
    }
  }
  // Move the overlapping floating label into a native placeholder (disappears on type).
  function relabel(root) {
    root.querySelectorAll('input, textarea').forEach(function (inp) {
      if (inp.dataset.agvRelabeled) return;
      var lbl = inp.nextElementSibling;
      if (lbl && lbl.className && /formInputFieldLabel/.test(lbl.className)) {
        var txt = (lbl.textContent || '').trim();
        if (txt) {
          if (!inp.getAttribute('placeholder') || !inp.getAttribute('placeholder').trim()) inp.setAttribute('placeholder', txt);
          if (!inp.getAttribute('aria-label')) inp.setAttribute('aria-label', txt);
          lbl.style.setProperty('display', 'none', 'important');
          inp.dataset.agvRelabeled = '1';
        }
      }
    });
  }
  function scan() {
    document.querySelectorAll('shopify-forms-embed, [id*="shopify-forms"], [class*="shopify-form"]').forEach(function (h) {
      if (h.shadowRoot) { inject(h.shadowRoot); relabel(h.shadowRoot); }
    });
  }
  scan();
  var tries = 0;
  var iv = setInterval(function () { scan(); if (++tries > 48) clearInterval(iv); }, 250);
  try { new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
